/**
 * 数据统计卡片组件
 * 用于展示关键指标和趋势
 */

import React from 'react';
import { Card, Typography } from 'antd';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  MinusOutlined,
} from '@ant-design/icons';
import './StatsCard.css';

const { Text } = Typography;

export interface StatsCardProps {
  title: string;
  value: string | number;
  unit?: string;
  suffix?: string;
  trend?: {
    value: number;
    type: 'increase' | 'decrease' | 'neutral';
    label?: string;
    suffix?: string;
  };
  icon?: React.ReactNode;
  loading?: boolean;
  description?: string;
  color?: 'blue' | 'purple' | 'green' | 'orange' | 'red' | 'cyan';
  onClick?: () => void;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  unit,
  suffix,
  trend,
  icon,
  loading = false,
  description,
  color = 'blue',
  onClick,
}) => {
  const getTrendIcon = () => {
    switch (trend?.type) {
      case 'increase':
        return <ArrowUpOutlined />;
      case 'decrease':
        return <ArrowDownOutlined />;
      case 'neutral':
        return <MinusOutlined />;
      default:
        return null;
    }
  };

  const getTrendColor = () => {
    switch (trend?.type) {
      case 'increase':
        return 'success';
      case 'decrease':
        return 'error';
      case 'neutral':
        return 'neutral';
      default:
        return 'neutral';
    }
  };

  return (
    <Card
      className={`stats-card stats-card-${color} ${onClick ? 'clickable' : ''}`}
      loading={loading}
      onClick={onClick}
      hoverable={!!onClick}
    >
      <div className="stats-card-content">
        {/* 图标区域 */}
        {icon && <div className="stats-card-icon">{icon}</div>}

        {/* 数据区域 */}
        <div className="stats-card-data">
          <Text className="stats-card-title">{title}</Text>
          
          <div className="stats-card-value-row">
            <span className="stats-card-value">
              {value}
              {(unit || suffix) && <span className="stats-card-unit">{unit || suffix}</span>}
            </span>
          </div>

          {/* 趋势指示器 */}
          {trend && (
            <div className={`stats-card-trend trend-${getTrendColor()}`}>
              {getTrendIcon()}
              <span className="trend-value">
                {trend.value > 0 && '+'}
                {trend.value}{trend.suffix || '%'}
              </span>
              {trend.label && <span className="trend-label">{trend.label}</span>}
            </div>
          )}

          {/* 描述文本 */}
          {description && (
            <Text className="stats-card-description">{description}</Text>
          )}
        </div>
      </div>
    </Card>
  );
};

export default StatsCard;

